<div class="starRatingContainer" #divWithDir>
  <span
    *ngFor="let ratingId of ratingArray; index as i"
    [id]="'star_' + i"
    (click)="calculateRating(i + 1)"
    class="material-symbols-outlined"
    [ngClass]="isStarFilled(i) ? 'star-fill' : ''"
  >
    star
  </span>
</div>
